<template>
  <div class="blocks">
    <v-row class="py-1 ma-0">
      <v-col
        class="d-flex justify-center align-center" 
        style="padding: 6px"
        cols="4" 
        sm="2" 
        md="2" 
        lg="1" 
        xl="1" 
        v-for="member in blockList"
      >
        <v-menu 
          bottom 
          open-on-hover 
          content-class="profile-card"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="member" v-bind="attrs" v-on="on">
              <v-avatar size="100%" min-height="100">
                <v-img aspect-ratio="1" :src="$HOST_URL + member.usericon"/>
              </v-avatar>
              <div class="text-ellipsis text-center mt-1" :title="member.nickname">{{ member.nickname }}</div>
            </div>
          </template>
          <v-card class="pa-4">
            <v-list-item class="pa-0 mb-4">
              <v-list-item-avatar size="50" tile>
                <v-avatar tile>
                  <v-img :src="$HOST_URL + member.usericon"/>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-regular mb-1">
                  {{ member.nickname }}
                </v-list-item-title>
                <!-- <v-rating
                  x-small
                  dense
                  readonly
                  half-increments
                  :value="5"
                  background-color="yellow darken-2"
                  color="yellow darken-2"
                ></v-rating> -->
              </v-list-item-content>
            </v-list-item>
            <span>
              <v-btn dark v-if="true" block class="mt-4 pink">追蹤用戶</v-btn>
              <v-btn dark v-else block class="mt-4 pink">取消追蹤</v-btn>
            </span>
            <span @click.stop="$store.dispatch('seller/block', member.id)">
              <v-btn v-if="!isBlock(member.id)" dark block color="red darken-2" class="mt-4">封鎖</v-btn>
              <v-btn v-else dark block outlined color="red darken-2" class="mt-4">已封鎖</v-btn>
            </span>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapState('seller', ['blockList'])
  },
  methods: {
    isBlock(id) {
      return this.blockList.map(member => member.id).includes(id)
    },
  }
}
</script>

<style lang="scss" scoped>
.blocks {
  .member {
    @extend .pointer;
    padding: 4px;
    overflow: auto;
    font-size: 14px;
    width: 100%;
    &:hover {
      transform: scale(1.015);
    }
  }
}
</style>